import { useState } from 'react';
import { rangeForPreset, todayRomeDateString } from '../../../utils/courseSessionPattern';

export function useEnrollmentPeriod() {
    const today = todayRomeDateString();
    const initial = rangeForPreset('6m', today);
    const [preset, setPreset] = useState('6m');
    const [from, setFrom] = useState(initial.from);
    const [to, setTo] = useState(initial.to);

    const applyPreset = (id) => {
        const next = rangeForPreset(id, today);
        setPreset(id);
        setFrom(next.from);
        setTo(next.to);
    };

    const updateFrom = (value) => {
        setPreset('custom');
        setFrom(value);
        if (to && value && value > to) setTo(value);
    };

    const updateTo = (value) => {
        setPreset('custom');
        if (from && value && value < from) {
            setTo(from);
            return;
        }
        setTo(value);
    };

    return { preset, from, to, today, applyPreset, updateFrom, updateTo };
}
